import React, { useContext } from 'react';
import { pdpSubLabels } from '@tcp/core/src/utils/labels/browse/PDP.labels.js';
import { BadgesContext } from '../../../context/Badges.context';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';
import LastPurchasedStyles from '../styles/LastPurchasedSection.style';
import withStyles from '../../../../../../common/hoc/withStyles';

const LastPurchasedSection = ({ className }) => {
  const { previouslyPurchasedBadgeData, productId, isLoggedIn, isLastPurchasedEnabled } =
    useContext(BadgesContext);
  const lastPurchasedtxt = renderLabel(
    getLabelFromCopyOrFromTranslation('ProductDetailPage.PDP_Sub.lbl_last_purchased', pdpSubLabels),
    'lbl_last_purchased'
  );
  const lastPurchasedData = previouslyPurchasedBadgeData?.find(
    (obj) => obj?.productId === productId
  );

  const lastPurchasedSizeAry = [];
  if (lastPurchasedData) {
    lastPurchasedData?.items?.forEach((item) => {
      lastPurchasedSizeAry.push(item?.size);
    });
  }

  const checkToShowLastPurchasedLabel =
    isLoggedIn && isLastPurchasedEnabled && lastPurchasedSizeAry.length > 0;

  return (
    checkToShowLastPurchasedLabel && (
      <div className={`${className} last-purchased`}>
        [{lastPurchasedtxt}:{' '}
        <span className="last-purchased-values">{lastPurchasedSizeAry.join(',')}</span>]
      </div>
    )
  );
};

export default withStyles(LastPurchasedSection, LastPurchasedStyles);
